import resolveResponsiveValue from '../../resolvers/ResponsiveValueResolver';
export default function resolveOpacity(theme, screenWidth, opacitySupport) {
    var result = {};
    if (opacitySupport.opacity !== undefined) {
        result.opacity = resolveResponsiveValue(theme, screenWidth, opacitySupport.opacity);
    }
    return result;
}
//# sourceMappingURL=OpacityResolver.js.map